import {
  Clock,
  FileText,
  Folder,
  History,
  MessageSquare,
  type LucideIcon,
} from "lucide-react";
import type { ChatHistoryIcon } from "../types";

const ICONS: Record<ChatHistoryIcon, LucideIcon> = {
  message: MessageSquare,
  clock: Clock,
  file: FileText,
  folder: Folder,
  history: History,
};

type Props = {
  icon: ChatHistoryIcon;
  className?: string;
};

export function AIChatHistoryIcon({ icon, className = "h-4 w-4" }: Props) {
  const Icon = ICONS[icon] ?? MessageSquare;
  return <Icon className={className} aria-hidden />;
}
